import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  drawerWrapper: {
    backgroundColor: theme.palette.background.paper,
    width: '250px',
    padding: '30px 10px 0 10px',
    height: '100vh',
    position: 'fixed',
  },
  mainIconButton: {
    fontSize: '16px',
  },
  metadataIconButton: {
    fontSize: '13px',
  },
  pageContentIconButton: {
    fontSize: '13px',
  },
  mediaPageIconButton: {
    fontSize: '13px',
  },
  libraryItemWrapper: {
    fontSize: '13px',
  },
  versionNumber: {
    padding: '0 10px',
    position: 'absolute',
    bottom: 140,
  },
  totalCount: {
    padding: '0 10px',
    position: 'absolute',
    bottom: 100,
  },
  libraryItems: {
    display: 'flex',
    flexDirection: 'column',
    width: '40px',
  },
  treeViewWrapper: {
    padding: '6px 7px',
  },
  treeItemWrapper: {
    fontSize: '16px',
  },
  sectionHeader: {
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
  },
  sectionContent: {
    marginLeft: '16px',
  },
  infoParent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '0 10px',
    bottom: 140,
    position: 'absolute',
  },
  red: {
    color: theme.palette.error.main,
  },
  infoItem: {
    fontSize: '14px',
  },
}));

export default useStyles;
